import useGetBasePath from "@/hooks/useGetBasePath";
import { moduleNameMapping } from "@/lib/main";

const ModuleName = () => {
  const moduleName = useGetBasePath(0);
  return (
    <div className="flex items-center font-bold text-[#464E5F] justify-center">
      {moduleNameMapping.get(moduleName)}
    </div>
  );
};

export default ModuleName;
